export * from './userPortal.service';
import { UserPortalService } from './userPortal.service';
export const APIS = [UserPortalService];
